import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Grid from '@mui/material/Grid';
import Toolbar from '@mui/material/Toolbar';
import logo from './LogoColoredTransparentSmall.png';
import OperatorLogout from '../../login/components/OperatorLogout';
import PropTypes from 'prop-types';
import {Tab, Tabs} from '@mui/material';

function Header({onAuthChange, showTabs}) {
  return (
    <React.Fragment>
      <AppBar
        component="div"
        color="primary"
        position="static"
        elevation={0}
        sx={{zIndex: 0}}
      >
        <Toolbar>
          <Grid container alignItems="center" justifyContent={'space-between'} spacing={1}>
            <Grid item xs={1}>
              <OperatorLogout onLogoutAttempt={onAuthChange}/>
            </Grid>
            <Grid item align={'center'} sx={{height: '10vh'}}>
              <img src={logo} className="logo" alt="Logo"/>
            </Grid>
            <Grid item xs={1}>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <AppBar component="div" position="static" elevation={0} sx={{zIndex: 0}}>
        {showTabs &&
          <Tabs value={0} textColor="inherit" centered>
            <Tab label="Assign Player Names" value={0}/>
          </Tabs>}
      </AppBar>
    </React.Fragment>
  );
}

Header.propTypes = {
  onAuthChange: PropTypes.func.isRequired,
  showTabs: PropTypes.bool.isRequired,
};

export default Header;
